import React from 'react'
import { Link } from 'react-router-dom'
import "./navbar.css"
const Navbar = () => {
  return (
    <div className='navbar'>
      <div className="container">
        <div className="logo">
           <h2>TecnoBlog</h2>
        </div>
        <div className="links">
          <Link className='link' to="/?cat=Artificial Intelligence">
            <h6>ARTIFICAL INTELLIGENCE</h6>
          </Link>
          <Link className='link' to="/?cat=Apps">
            <h6>APPS</h6>
          </Link>
          <Link className='link' to="/?cat=Hardware">
            <h6>HARDWARE</h6>
          </Link>
          <Link className='link' to="/?cat=Programming">
            <h6>PROGRAMMING</h6>
          </Link>
          <span>John</span>
          <span>Logout</span>
          <span className='writebtn'>
            <Link className="link" to="/write">Write</Link>
          </span>
        </div>
      </div>
    </div>
  )
}

export default Navbar